import React from "react";
import getYouTubeId from "get-youtube-id";
import YouTube from "react-youtube";
import ButtonSolid from "../Button/ButtonSolid";
import PortableText from "./portableText";
import MicroModal from "micromodal";
import { Link } from "gatsby";

const serializers = {
  types: {
    youtube: ({ node }) => {
      const { url } = node;
      const id = getYouTubeId(url);
      return <YouTube videoId={id} />;
    },
    iframe: ({ node }) => {
      const { url, height } = node;
      return <iframe title="Iframe" src={url} width="100%" height={`${height}px`} />;
    },
    button: ({ node }) => {
      const { action, label, slug, modal } = node;

      const handleClick = () => {
        MicroModal.show("modal-contact");
      };

      if (action === "form") {
        return (
          // <button
          //   //data-micromodal-trigger="modal-contact"
          //   data-modal-open="modal-contact"
          //   // onClick={handleClick}
          //   className="group relative overflow-hidden min-w-[184px] h-[51px] px-6 inline-flex items-center justify-center text-center font-body font-semibold no-underline whitespace-nowrap bg-primary-600 hover:bg-primary-600 text-white hover:text-white w-full lg:w-auto mb-8 cursor-pointer"
          // >
          //   {label}
          // </button>
          <ButtonSolid
            modal="modal-contact"
            text={label}
            className="w-full lg:w-auto mb-8"
            onClick={handleClick}
          />
        );
      } else {
        return <div>{label}</div>;
      }
    },
    table: ({ node }) => {
      const { rows, columns } = node;
      if (rows) {
        return (
          <div className="sanityTable w-full flex flex-col border-[1px] border-white mb-8">
            {rows.map((row, index) => (
              <div
                key={index}
                className={`${columns === "2" ? "grid-cols-2" : "grid-cols-3"} grid`}
              >
                <div className="border-[1px] border-white p-1 border-collapse">
                  <PortableText blocks={row.column1} />
                </div>
                <div className="border-[1px] border-white p-1 border-collapse">
                  <PortableText blocks={row.column2} />
                </div>
                {columns === "3" && (
                  <div className="border-[1px] border-white p-1 border-collapse">
                    <PortableText blocks={row.column3} />
                  </div>
                )}
              </div>
            ))}
          </div>
        );
      }
    },
    framedText: ({ node }) => {
      const { identifier, title, content } = node;
      if (title && content) {
        return (
          <div className="flex flex-col gap-y-1 pt-5 pb-2 px-[29px] border-[1px] border-[#F19A49]">
            <div className="text-[#EDE3D8] font-bold">{title}</div>
            <PortableText blocks={content} />
          </div>
        );
      }
    },
  },
  marks: {
    form: ({ children, mark }) => {
      switch (mark.formName) {
        case "Contact Us":
          return (
            <span
              data-modal-open="modal-contact"
              className="cursor-pointer !text-[#d58b45] hover:!text-[#b1753e]"
            >
              {children}{" "}
            </span>
          );
        default:
          return <span>{children}</span>;
      }
    },
    link: ({ children, mark }) => {
      // console.log("mark link", mark);
      // const { href } = mark;
      if (!mark.href.startsWith("/")) {
        return (
          <a href={mark.href} target="_blank" rel="noreferrer noopener">
            {children}
          </a>
        );
      } else {
        return <Link to={mark.href && mark.href}>{children}</Link>;
      }
    },
  },
};

export default serializers;
